module.exports = __webpack_public_path__ + "img/mabatfooter.f2750178.svg";